<!--
NOTE:
serialNumber                 病历编号
-->
<script setup>
import { HD_bySerialNumber, HD_byId } from '@/api/workPlace/prescription'
import { BASE_LABEL, columnHealth, columnOrder, columnSaleWestern, getStatusImg } from './config'
import { defineProps, defineEmits, ref, reactive, onMounted, computed } from 'vue'
import { SummaryPannel } from '@/views/WorkPlace/Container/chat/components'
const prop = defineProps({
  // 病历编号
  serialNumber: {
    type: String,
    default: ''
  },
  // 病历编号
  id: {
    type: [String, Number],
    default: '0'
  }
})
const emit = defineEmits('noDetail')
// 渲染基本信息 辅助方
const columnsBase = ref([...BASE_LABEL])
// 渲染数据
const info = reactive({
  // 基本信息
  base: {},
  // 药品信息
  drugs: [],
  // 订单信息
  orderInfo: [],
  // 售后信息
  postSaleVOS: []
})
const activeKey = ref('0')
/**
 * @description: 处方状态
 * 当前使用的是什么处方状态,不同值对应不同图片
 * @return {String} 0-已购买 1-未购买 2-已失效 3-已作废
 */
//const imgStatus = ref(0)
const loading = ref(false)
const totalAmount = ref(0)
// 获取详情数据
// 健康详情
async function detailHealth() {
  loading.value = true
  info.base = {}
  info.base.patientGender = ''
  info.drugs.splice(0)
  //imgStatus.value = 0
  let result = null
  if (prop.serialNumber) {
    try {
      result = await HD_bySerialNumber(prop.serialNumber)
    } catch (error) {
      emit('noDetail', '', prop.serialNumber)
    }
  } else {
    try {
      result = await HD_byId(prop.id)
    } catch (error) {
      emit('noDetail', prop.id, '')
    }
  }
  const [tmp] = result
  info.base = tmp
  info.base.patientGender = info.base.patientGender === 1 ? '男' : '女'
  //invalid 作废状态 0-未作废 1-已作废
  //expireStatus 过期状态 0-未过期 1-已过期
  /**
   * NOTE:判断状态 已失效状态特殊处理
   * 处方状态图 0：未购， 1：已全部购买， 2：待支付，3 已作废 4:已取消，5已删除 ，6已失效 ，7已作废
   * 未购买如果超时就是失效，未超时就是未购买
   * 未购买优先展示作废，未作废就是未购买
   * 已经购买如果取消就是取消，未取消就是已经购买
   */
  // if (tmp.status === 0 && tmp.invalid === 1) {
  //   imgStatus.value = 6
  // } else if (tmp.status === 0 && tmp.expireStatus === 1) {
  //   imgStatus.value = 7
  // } else {
  //   imgStatus.value = tmp.status
  // }
  info.drugs = tmp.skuItems
  // 订单详情列表
  info.orderInfo = tmp.orderInfoVOS || []
  // 售后列表
  info.postSaleVOS = tmp.postSaleVOS || []
  loading.value = false
  totalAmount.value = tmp.prescriptionAmount
  // 商品总额
}
const summaryPanelVisible = ref()
const chatSummaryId = ref()
// 待购工单AI语音优化 失效打开小结详情
const openSummaryPanel = () => {
  summaryPanelVisible.value = true
  chatSummaryId.value = info.base.chatSummaryId
}

onMounted(() => {
  detailHealth()
})
</script>
<template>
  <div class="health">
    <div class="head">
      <h3 class="head-left">基本信息</h3>
      <div class="head-right">
        <!-- 待购工单AI语音优化 失效打开小结详情 -->
        <a-button
          size="small"
          v-if="!!info.base.chatSummaryId"
          @click="openSummaryPanel"
          type="primary"
          ghost
        >
          未购原因
        </a-button>
        <span class="serialNumber">编号{{ info.base.serialNumber }}</span>
        <span>开方时间{{ info.base.createdAt }}</span>
      </div>
    </div>
    <!-- 病历信息 -->
    <ul class="detail_info">
      <auth-img
        class="detail_info-status"
        :src="getStatusImg(info.base)?.src"
        :alt="getStatusImg(info.base)?.alt"
      />
      <li
        class="detail_info-item"
        v-for="column in columnsBase"
        :class="column.class"
        :key="column"
      >
        <label class="item_label">{{ column.label }}</label>
        <span v-if="column.render" class="item_content">
          {{ column.render(info.base[column.prop], info.base) }}
        </span>
        <span v-else class="item_content">
          {{ info.base[column.prop] }}
          <!-- 如果是岁的话带年级单位 -->
          <label v-if="column.prop === 'patientAge'">
            {{ info.base.patientAgeUnit }}
          </label>
        </span>
      </li>
    </ul>
    <!-- 药品信息 -->
    <a-tabs class="detail_drugs" v-model:activeKey="activeKey">
      <a-tab-pane key="0" tab="商品信息">
        <a-table
          :transformCellText="({ text }) => text ?? '--'"
          :rowKey="(record, index) => index"
          :pagination="false"
          :dataSource="info.drugs"
          :columns="columnHealth"
          :scroll="{ y: 360, x: '100%' }"
        />
        <h3 class="total">总金额：{{ totalAmount }}元</h3>
      </a-tab-pane>
      <a-tab-pane key="1" tab="订单信息">
        <a-table
          :transformCellText="({ text }) => text ?? '--'"
          :rowKey="(record, index) => index"
          :pagination="false"
          :dataSource="info.orderInfo"
          :columns="columnOrder"
          :scroll="{ y: 360, x: '100%' }"
        >
          <template #reviewContent="text">
            <a-popover
              :overlayStyle="{ width: '310px' }"
              placement="topLeft"
              v-if="text.record.reviewContent"
              class="order-info-tooltip"
            >
              <template #content>
                <span class="comment-body">{{ text.record.reviewContent }}</span>
              </template>
              <span class="comment">{{ text.record.reviewContent }}</span>
            </a-popover>
            <span v-else>--</span>
          </template>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="售后信息">
        <a-table
          :transformCellText="({ text }) => text ?? '--'"
          :rowKey="(record, index) => index"
          :pagination="false"
          :dataSource="info.postSaleVOS"
          :columns="columnSaleWestern"
          :scroll="{ y: 360, x: '100%' }"
        />
      </a-tab-pane>
    </a-tabs>
    <!-- 沟通小结 -->
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <SummaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible = false"
      />
    </a-modal>
  </div>
</template>
<style lang="scss" scoped>
.health {
  .head {
    display: flex;
    justify-content: space-between;

    .head-left {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }

    .head-right {
      color: #999999;
      font-weight: 400;
      font-size: 14px;

      .serialNumber {
        margin: 0 32px;
      }
    }
  }

  .detail_info {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    grid-template-rows: repeat(2, minmax(44px, auto));
    list-style: none;
    margin: 0;
    padding-left: 0;
    grid-gap: 5px 0;
    position: relative;
    margin-bottom: 30px;

    &-status {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      transform: translateY(-30px);
      width: 120px;
    }

    &-item {
      padding: 20px 0 20px 16px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;

      .item_label {
        flex-shrink: 0;
        color: #999999;
        margin-right: 3px;
      }

      .item_content {
        flex: auto;
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        font-weight: bold;

        &:after {
          content: '';
          display: block;
          width: 1px;
          background: #e8e8e8;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }

      // 最后一列去掉灰色的竖线
      &:nth-child(4) .item_content:after,
      &:nth-child(6) .item_content:after {
        background: transparent;
      }

      &:nth-child(2),
      &:nth-child(5) {
        padding-left: 0;
      }
    }

    // 网格布局大
    .big {
      grid-column-start: 2;
      grid-column-end: 4;
    }

    // 网格布局 巨大
    .large {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    // 网格布局 小
  }

  // 底部药品信息
  .detail_drugs {
    padding: 10px 0;

    .total {
      text-align: right;
    }
  }
}
.comment-body {
  color: black;
}
</style>
